<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-credit_limit"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
      :disabled="true"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "CreditLimit",
  components: {InputWidget},
  mixins: [BaseInputMixin('term.credit_limit')],

  data() {
    return {
      defaultLabel: this.$t("Credit Limit")
    }
  }
}
</script>

<style scoped>

</style>
